import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BreadcrumbsService } from '../breadcrumbs.service';
import { ScrollService } from '../scroll.service';
import { LangService } from '../lang.service';
import { Subscription } from 'rxjs';

interface IRouteParam {
  [key: string]: any
}

@Component({
  selector: 'route-view-base',
  templateUrl: './route-view-base.component.html',
  styleUrls: ['./route-view-base.component.scss']
})
export class RouteViewBaseComponent implements OnInit, OnDestroy {

  public requireLogin = true;
  public routeSub:Subscription;
  public breadcrumb = [];
  
  constructor(
    private breadcrumbsService: BreadcrumbsService,
    private router:Router,
    private route:ActivatedRoute,
    private scrollService:ScrollService,
    private langService:LangService,
  ) { }

  ngOnInit() {
    this.scrollService.scrollToTop();
    this.routeSub = this.route.params.subscribe( (routeParams:IRouteParam) => {
      this.captureRouteParams(routeParams);
      this.defineBreadCrumbs();
      this.initRouteView()
    });
  }

  ngOnDestroy() {
    this.routeSub.unsubscribe();
  }

  captureRouteParams(routeParams:IRouteParam){
    // use super
    this.langService.setCurrentLanguage(routeParams['lang']);
  }

  defineBreadCrumbs(){
    // safe to override (no super)
    const defaultPageName = (this.router.url).split('/').pop();
    this.breadcrumb = [
      this.breadcrumbsService.HOME(),
      this.breadcrumbsService._CURRENT(defaultPageName, this.router.url),
    ]
  }

  initRouteView() {

  }

}
